import { Link } from "react-router";

export function Logo({ tone = "dark" }: { tone?: "dark" | "light" } = {}) {
  return (
    <Link to="/" className="inline-flex min-h-11 items-center gap-3" aria-label="Agentic Plus home">
      <svg viewBox="0 0 64 64" className="size-9" aria-hidden="true">
        <rect width="64" height="64" rx="16" fill="#10233f" />
        <path d="M20 43 32 19l12 24h-7.2L32 33.4 27.2 43z" fill="#7ff0d3" />
        <rect x="36" y="14" width="12" height="4" rx="2" fill="#f7c948" />
        <rect x="40" y="10" width="4" height="12" rx="2" fill="#f7c948" />
      </svg>
      <span className="font-display text-lg font-bold tracking-tight">
        Agentic <span className={tone === "light" ? "text-mint" : "text-mint-dark"}>Plus</span>
      </span>
    </Link>
  );
}
